import { connect } from "react-redux";
import DisplayActions from "../../../../redux/DisplayRedux";
import UserAccountActions from "../../../../redux/UserAccountRedux";
import ScreenDetail from "../components/detail/ScreenDetail";

const mapStateToProps = ({ display, userAccount }) => ({
  user: userAccount.user,
  token: userAccount.token,
  currentDisplay: display.currentDisplay,
  currentCampaign: display.currentCampaign,
  fetchingDisplayInfo: display.fetchingDisplayInfo,
  client: display.client,
  userCurrency: userAccount.currency,
  initialCurrency: display.currency,
  invoiceIssuingCountry: userAccount.invoiceIssuingCountry,
  campaignInvoiceIssuingCountry: display.campaignInvoiceIssuingCountry,
  external_dsp_id: display.external_dsp_id,
  editCampaignActive: display.editCampaignActive,
  date_from: display.date_from,
  date_to: display.date_to,
  programmatic: display.programmatic,
  campaignCurrency: display.campaignCurrency,
  isGuaranteed: display.isGuaranteed,
  audienceDaysOfWeek: display.audienceDaysOfWeek,
  audienceHoursOfDay: display.audienceHoursOfDay,
  audienceQualitative: display.audienceQualitative,
  errors: display.errors,
});

const mapDispatchToProps = (dispatch) => ({
  getDisplayInfoRequest: (id, clientId, currency, invoice_issuing_country, external_dsp_id) =>
    dispatch(
      DisplayActions.getDisplayInfoRequest(id, clientId, currency, invoice_issuing_country, external_dsp_id)
    ),
  getAudienceDaysOfWeekRequest: (params) =>
    dispatch(DisplayActions.getAudienceDaysOfWeekRequest(params)),
  getAudienceHoursOfDayRequest: (params) =>
    dispatch(DisplayActions.getAudienceHoursOfDayRequest(params)),
  getAudienceQualitativeRequest: (displayId) =>
    dispatch(DisplayActions.getAudienceQualitativeRequest(displayId)),
  addDisplayToCartById: (params) =>
    dispatch(DisplayActions.addDisplayToCartByIdRequest(params)),
  setShouldPromptLogin: (value, target) =>
    dispatch(UserAccountActions.setShouldPromptLogin(value, target)),
  logout: () => dispatch(UserAccountActions.userLogout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScreenDetail);
